export default "__VITE_ASSET__FzP5tpbD__"